// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bold-hack[data-v-fb73fee2]:after{contain:content;content:attr(title);display:block;font-size:1.4rem;font-weight:500;height:0;line-height:1.6rem;overflow:hidden;visibility:hidden}.hide-menu .menu[data-v-fb73fee2]{opacity:0}.shadow-border[data-v-fb73fee2]:hover{box-shadow:inset 0 -2px 0 #111}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
